import {Colors} from '@wandb/common/css/globals.styles';
import styled from 'styled-components';

export const JobAliasOption = styled.div`
  display: flex;
  align-items: center;
`;
JobAliasOption.displayName = 'S.JobAliasOption';

export const Alias = styled.div`
  flex: 1 1 auto;
`;
Alias.displayName = 'S.Alias';

export const AliasVersion = styled.div`
  color: ${Colors.GRAY_500};
`;
AliasVersion.displayName = 'S.AliasVersion';
